import { HawkSearchComponents, Sorting, SortingComponentConfig, SortingComponentModel } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../../base.component';
import defaultHtml from './sorting.component.hbs';

export class SortingComponent extends BaseComponent<SortingComponentConfig, Sorting, SortingComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'sorting';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = true;

    protected override renderContent(): boolean {
        return !!this.data?.options?.length;
    }

    protected override getContentModel(): SortingComponentModel {
        return {
            options: this.data!.options
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-sort]').forEach((e) => {
            e.addEventListener('change', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLSelectElement;
                const value = element.value;

                searchService.sort(value);
            });
        });
    }
}
